import React from 'react';
import classnames from 'classnames';
import { forceCheck } from 'react-lazyload';
import LazyLoad from 'react-lazyload';
import CategoryLink from 'shared/components/categoryLink';
import {
  BEER,
  WINE,
  RED_WINE,
  WHITE_WINE,
  MORE_WINES,
  SPIRITS,
  MORE
} from './config';
import { MutedBackground } from 'scy/Background';
import { AccentH5 } from 'scy/text';
import {
  sansSerifBlack,
  uppercase,
  letterSpacingM,
  fontSizeXS
} from 'scy/text/styles.mod.scss';
import { block, inlineBlock } from 'scy/display.mod.scss';
import padding from 'scy/padding.mod.scss';
import ArrowIcon from 'images/icons/controls/chevron-right.svg?react-svg';
import styles from './styles.mod.scss';

const NavItemLabel = ({ children }) => (
  <AccentH5 tag="span" className={styles.navItemLabel}>
    {children}
  </AccentH5>
);

const CategoryNavItem = ({ tag, url, name, img, children }) => (
  <div
    className={classnames({ [styles.hoverable]: img }, styles.navItem)}
    onMouseOver={img ? () => forceCheck() : null}
  >
    <CategoryLink tag={tag} url={url} name={name}>
      {({ name }) => <NavItemLabel>{name}</NavItemLabel>}
    </CategoryLink>
    <div className={styles.dropdown}>
      {children}
      <div className={styles.imageContainer}>
        {img ? (
          <LazyLoad once={true} height={img.height}>
            <img
              src={img.src}
              className={styles.menuImage}
              alt={`${name} category header image`}
            />
          </LazyLoad>
        ) : null}
      </div>
    </div>
  </div>
);

const Column = ({ children }) => (
  <div className={styles.dropdownColumn}>{children}</div>
);

const ColumnHeading = ({ tag, name }) => (
  <CategoryLink
    tag={tag}
    name={name}
    className={classnames(
      block,
      sansSerifBlack,
      uppercase,
      letterSpacingM,
      padding.bottom_sm,
      padding.right_sm
    )}
  />
);

const CategoryList = ({ categories }) =>
  categories.map(({ tag, name }) => (
    <CategoryLink
      key={tag}
      tag={tag}
      name={name}
      className={classnames(block, padding.bottom_sm, padding.right_sm)}
    >
      {({ name }) => (
        <span className={styles.navLinkDropdownLabel}>{name}</span>
      )}
    </CategoryLink>
  ));

const ViewMore = ({ tag }) => (
  <CategoryLink tag={tag}>
    <span
      className={classnames(
        inlineBlock,
        padding.right_xxs,
        sansSerifBlack,
        uppercase,
        letterSpacingM,
        fontSizeXS
      )}
    >
      All
    </span>
    <ArrowIcon height={9} />
  </CategoryLink>
);

export default function HeaderNav() {
  return (
    <MutedBackground className={styles.navLeft}>
      <CategoryNavItem tag={BEER.tag} img={BEER.img} name={BEER.name}>
        <Column>
          <CategoryList categories={BEER.subcategories.slice(0, 5)} />
        </Column>
        <Column>
          <CategoryList categories={BEER.subcategories.slice(5, 10)} />
        </Column>
        <Column>
          <CategoryList categories={BEER.subcategories.slice(10)} />
          <ViewMore tag={BEER.tag} />
        </Column>
      </CategoryNavItem>

      <CategoryNavItem tag={WINE.tag} img={WINE.img}>
        <Column>
          <ColumnHeading tag={RED_WINE.tag} />
          <CategoryList categories={RED_WINE.subcategories} />
          <ViewMore tag={RED_WINE.tag} />
        </Column>
        <Column>
          <ColumnHeading tag={WHITE_WINE.tag} />
          <CategoryList categories={WHITE_WINE.subcategories} />
          <ViewMore tag={WHITE_WINE.tag} />
        </Column>
        <Column>
          <ColumnHeading tag={WINE.tag} name="More Wines" />
          <CategoryList categories={MORE_WINES} />
          <ViewMore tag={WINE.tag} />
        </Column>
      </CategoryNavItem>

      <CategoryNavItem tag={SPIRITS.tag} img={SPIRITS.img}>
        <Column>
          <CategoryList categories={SPIRITS.subcategories.slice(0, 5)} />
        </Column>
        <Column>
          <CategoryList categories={SPIRITS.subcategories.slice(5, 10)} />
        </Column>
        <Column>
          <CategoryList categories={SPIRITS.subcategories.slice(10)} />
          <ViewMore tag={SPIRITS.tag} />
        </Column>
      </CategoryNavItem>

      <CategoryNavItem tag={MORE.subcategories[2].tag} name="tobacco" />

      <div className={styles.navItem}>
        <a href="/gifting">
          <NavItemLabel>Gifts</NavItemLabel>
        </a>
      </div>

      <CategoryNavItem
        tag={MORE.tag}
        url={MORE.url}
        name={MORE.name}
        img={MORE.img}
      >
        <Column>
          <ColumnHeading tag={MORE.subcategories[0].tag} />
        </Column>
        <Column>
          <ColumnHeading tag={MORE.subcategories[1].tag} />
        </Column>
        <Column>
          <ColumnHeading tag={MORE.subcategories[2].tag} />
        </Column>
      </CategoryNavItem>
    </MutedBackground>
  );
}
